import EFVideoModal from '@/components/UI/EFVideoModal';
import Image from '@/components/UI/Image';
import { EFVideoRectPlay } from '@/components/UI/svg/EFVideoPlay';
import { EFYoutubeLive, Facebook, Instagram, PlayIcon, Youtube } from '@/components/UI/svg/YoutubeLive';
import { getHostApi } from '@/utils';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import { useGlobal } from '@/utils/useGlobal';
import { useRouter } from 'next/router';
import { useRef, useState } from 'react';
import css from './index.module.scss';
const videoSourceMap: any = {
    us: 'https://www.youtube.com/embed/B-3OgdLhzTw',
    de: 'https://www.youtube.com/embed/iVxnCkMkQZg',
    // cn: {
    //     SD: 'https://videos.ecoflow.com/414f233a732c497093a5ed9078c8eaad/8f00178764e54bc8b1913a8feff387d5-82da21de793746b6cea1259b31025f34-fd.mp4',
    //     HD: 'https://videos.ecoflow.com/414f233a732c497093a5ed9078c8eaad/8f00178764e54bc8b1913a8feff387d5-98ded41e8586415eb0a4f1e5ddd5561f-sd.mp4',
    //     '2K': 'https://videos.ecoflow.com/original/workflow/470d945a-1833b7e52ca-0004-9c91-e6d-40030.mp4',
    // },
};

const platformList = [
    {
        name: 'youtubelive.youtube',
        icon: <Youtube />,
        iconActive: <Youtube color="#FFF" />,
    },
    {
        name: 'youtubelive.facebook',
        icon: <Facebook />,
        iconActive: <Facebook color="#FFF" />,
    },
    {
        name: 'youtubelive.instagram',
        icon: <Instagram />,
        iconActive: <Instagram color="#FFF" />,
    },
];

const platformListH5 = [
    {
        name: 'youtubelive.youtube',
        icon: <Youtube width="23px" height="16px" />,
        iconActive: <Youtube color="#FFF" width="23px" height="16px" />,
    },
    {
        name: 'youtubelive.facebook',
        icon: <Facebook width="16px" height="16px" />,
        iconActive: <Facebook color="#FFF" width="16px" height="16px" />,
    },
    {
        name: 'youtubelive.instagram',
        icon: <Instagram width="16px" height="16px" />,
        iconActive: <Instagram color="#FFF" width="16px" height="16px" />,
    },
];

const PageName: any = {
    '/smart-devices-teaser': 'EcoFlow BLADE & GLACIER & WAVE 2',
    '/glacier-and-wave-2-teaser': 'EcoFlow GLACIER & WAVE 2',
    '/glacier-portable-refrigerator': 'EcoFlow GLACIER',
    '/wave-2-portable-air-conditioner': 'EcoFlow WAVE 2',
    '/blade-robotic-lawn-mower': 'EcoFlow BLADE',
};

export default function YoutubeLive({
    img = '/media/product-smart/live-bg-default.jpg',
    source = videoSourceMap,
    startTime = '2023/03/28 20:00:00 GMT+8',
    liveTime = 'April 26 at 9:00 AM',
    format = { d: true, h: true },
    liveContext = 'UPCOMING',
    youtubeLink = '',
    wrapperClass = '',
}) {
    const { useLang, getSystemTime, isMobile, Link, gtm } = useGlobal();
    const { locale = 'us', route = '/smart-devices-teaser' } = useRouter();
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const { t } = useLang('shared');
    // 服务器时间
    const serverTimeStamp: any = useRef(getSystemTime());
    // 活动时间
    const startTimeStamp = new Date(startTime).getTime();
    // 计时器
    const timer: any = useRef(null);
    // 时间差
    const [remainTime, setRemainTime] = useState(0);
    const [isLiving, setIsLiving] = useState(true);
    const [active, setActive] = useState(0);

    const getCountdownStr = (timestamp: number) => {
        if (typeof timestamp === 'number' && timestamp >= 0) {
            const time = Math.floor(timestamp / 1000);
            const d = Math.floor(time / (60 * 60 * 24));
            const h = Math.floor((time - d * 3600 * 24) / 60 / 60);
            const m = Math.floor((time - d * 3600 * 24 - h * 3600) / 60);
            const s = Math.floor(time - d * 3600 * 24 - h * 3600 - m * 60);
            const timeObj: any = {
                d,
                h,
                m,
                s,
            };
            const obj: any = {};
            for (const key in format) {
                obj[key] = timeObj[key];
            }
            return t.rich('youtubelive.countdown', obj);
        }
        return '';
    };

    const onVisibleChange = () => {
        if (window.document.visibilityState === 'visible') {
            serverTimeStamp.current = getSystemTime();
            if (serverTimeStamp.current < 1000000) {
                modifySysTime();
            }
        }
    };

    const onChangeLive = (i: number) => {
        setActive(0);
        // TODO 切换直播视频
    };

    // 纠正测试环境时间错误问题
    const modifySysTime = async () => {
        const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
        const headers = getDefaultHeader(locale);

        try {
            const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                headers,
            });
            const globalData = await spuData.json();
            serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
        } catch (e) {
            console.log(e);
        }
    };

    // useEffect(() => {
    //     if (serverTimeStamp.current < 1000000) {
    //         modifySysTime();
    //     }
    //     // 倒计时
    //     if (serverTimeStamp.current < startTimeStamp) {
    //         timer.current = setInterval(() => {
    //             serverTimeStamp.current += 1000;
    //             setRemainTime(startTimeStamp - serverTimeStamp.current);
    //             // 开始直播
    //             if (serverTimeStamp.current > startTimeStamp) {
    //                 setIsLiving(true);
    //                 clearInterval(timer.current);
    //             }
    //         }, 1000);
    //     } else {
    //         setIsLiving(true);
    //         clearInterval(timer.current);
    //     }
    //     if (typeof window !== 'undefined') {
    //         // 监听切屏事件
    //         window.document.addEventListener('visibilitychange', onVisibleChange);
    //     }
    // }, []);

    return (
        <div className={`youtube-live ${css.youtubeLive} ${isMobile ? 'youtube-live-h5' : 'youtube-live-pc'}`}>
            <div className={`viewport-wrapper ${wrapperClass}`}>
                {/* 1. 变量： 这里不能用NextImage 2: 定时器任务，EFPic会每秒重复创建图片导致图片一直闪，也不能使用 */}
                <div className="img-wrapper">
                    <Image src={img} noUseSrcset={true} layout="fill" alt={'EcoFlow'} />
                </div>
                {youtubeLink ? (
                    <Link target="_blank" href={youtubeLink}>
                        <div className="linker-btn">
                            <EFVideoRectPlay {...(isMobile && { width: 17, height: 12 })} />
                            <div className="linker-btn-text">{t('youtubelive.link_text')}</div>
                        </div>
                    </Link>
                ) : (
                    <div
                        className="play-btn"
                        onClick={() => {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'video',
                                title_name: `${PageName[route]} Launch Event`,
                                position: 'Product Preview_1',
                            });
                            setShowEFVideoModal(true);
                        }}
                    >
                        <PlayIcon />
                    </div>
                )}
                <div className="live-info-box">
                    {youtubeLink ? (
                        <></>
                    ) : isLiving ? (
                        <div className="live-tag">
                            <EFYoutubeLive />
                            <span className="text">{'LIVE'}</span>
                        </div>
                    ) : (
                        <div className="live-info">
                            {isMobile ? (
                                liveContext
                            ) : (
                                <>
                                    <EFYoutubeLive width="43px" height="30px" />
                                    <div className="time">
                                        <div className="remain-time">{getCountdownStr(remainTime)}</div>
                                        <div className="live-time">{liveTime}</div>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={source[locale] || source.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
